//import "lazysizes";
import ready, { HTML } from './utils/index';
import initMenu from './components/initMenu';
import initGSAP from './components/initGSAP';
import initChart from './components/initChart';
import initSwiper from './components/initSwiper';
import initCountUp from './components/initCountUp';
import initScrambleText from './components/initScrambleText';
import initSmoothScroll from './components/initSmoothScroll';
import initAccordions from './components/accordion';
import parallax from './components/parallax';
import initRadarAnimation from './animations/radar-animation';
import initKpiTrackerAnimation from './animations/kpi-tracker-animation';
import { initFilterCase } from './components/filter-case';

ready(() => {
  HTML.classList.add('is-loaded');
  initMenu();
  initGSAP();
  initChart();
  initSwiper();
  initCountUp();
  initScrambleText();
  initSmoothScroll();
  initAccordions();
  initRadarAnimation();
  initKpiTrackerAnimation();
  initFilterCase();
  parallax();
});
